import type { ReactNode } from 'react'
import { AlertIcon, InfoIcon, WarningIcon } from '@/components/icons'
import { cx } from './internal/cx'
import './Banner.css'

export type BannerTone = 'info' | 'warning' | 'error'

export type BannerProps = {
  tone: BannerTone
  children: ReactNode
  /** Optional trailing action (e.g. a ghost Button). */
  action?: ReactNode
}

const TONE_ICON: Record<BannerTone, ReactNode> = {
  info: <InfoIcon size={18} />,
  warning: <WarningIcon size={18} />,
  error: <AlertIcon size={18} />,
}

/** Persistent inline banner with aria-live feedback; icon + text per tone. */
export function Banner({ tone, children, action }: BannerProps) {
  return (
    <div className={cx('ui-banner', `ui-banner--${tone}`)} role={tone === 'error' ? 'alert' : 'status'} aria-live={tone === 'error' ? 'assertive' : 'polite'}>
      <span className="ui-banner__icon">{TONE_ICON[tone]}</span>
      <div className="ui-banner__content">{children}</div>
      {action && <div className="ui-banner__action">{action}</div>}
    </div>
  )
}
